/**
 * HUB-D — Contrôles vue mensuelle (mois + export).
 */
import React from 'react';
import { Download } from 'lucide-react';

export default function ActiviteCaisseMonthlyControls({
  month,
  onMonthChange,
  onRefresh,
  onExport,
  loading,
  testIdPrefix = 'activite-caisse',
}) {
  return (
    <div
      className="rounded-xl border p-4 flex flex-col sm:flex-row sm:items-end gap-3"
      style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
      data-testid={`${testIdPrefix}-monthly-controls`}
    >
      <div className="flex-1 min-w-0">
        <label className="block text-xs text-[var(--rm-gray-500)] mb-1">Mois</label>
        <input
          type="month"
          value={month}
          onChange={(e) => onMonthChange(e.target.value)}
          className="input-dark py-2.5 min-h-[44px] text-sm w-full max-w-xs"
          data-testid={`${testIdPrefix}-month-input`}
        />
      </div>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={onRefresh}
          disabled={loading}
          className="btn-secondary px-4 py-2.5 min-h-[44px] text-sm"
          data-testid={`${testIdPrefix}-month-filter`}
        >
          Actualiser
        </button>
        <button
          type="button"
          onClick={onExport}
          className="btn-accent px-4 py-2.5 min-h-[44px] text-sm inline-flex items-center gap-2"
          data-testid={`${testIdPrefix}-month-export`}
        >
          <Download className="w-4 h-4" />
          Export CSV
        </button>
      </div>
    </div>
  );
}
